export function buildEmailTestPayload({
  toEmail,
  fromEmail,
  fromName,
  subject,
  message,
  htmlLinkUrl,
  htmlLinkLabel,
  trackingLoads,
  trackingClicks,
}) {
  const payload = {
    to_email: toEmail,
    from_email: fromEmail,
    subject,
    message,
    tracking_loads: Boolean(trackingLoads),
    tracking_clicks: Boolean(trackingClicks),
  };

  const normalizedFromName = (fromName ?? "").trim();
  if (normalizedFromName) {
    payload.from_name = normalizedFromName;
  }

  const normalizedHtmlLinkUrl = (htmlLinkUrl ?? "").trim();
  if (normalizedHtmlLinkUrl) {
    payload.html_link_url = normalizedHtmlLinkUrl;
    const normalizedHtmlLinkLabel = (htmlLinkLabel ?? "").trim();
    if (normalizedHtmlLinkLabel) {
      payload.html_link_label = normalizedHtmlLinkLabel;
    }
  }

  return payload;
}
